var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAcademiaProfile = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    ry: 24,
    fill: "#141413"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.108 32.566v1.255h-11.27v-1.255c1.884-.034 2.808-.43 2.808-1.488 0-.363-.137-.794-.307-1.29l-1.273-3.08h-8.772a802.398 802.398 0 01-1.36 3.412c-.823 2.007.31 2.252 2.246 2.444l.012.002v1.255H12v-1.255c.926-.166 1.678-.33 1.987-1.223l7.33-18.242-1.096-2.61h6.2l8.666 20.852c.307.825 1.06 1.057 2.02 1.223zm-10.572-8.567l-3.366-8.596L19.93 24h6.607z",
    fill: "#fff"
  })));
};
export default SvgAcademiaProfile;